class QuickView {
  constructor() {
    this.modal = document.getElementById('quick-view-modal');
    if (!this.modal) return;
    
    this.closeBtn = this.modal.querySelector('.qv-close');
    this.overlay = this.modal.querySelector('.qv-modal-overlay');
    this.form = document.getElementById('qv-add-to-cart-form');
    this.currentProduct = null;
    
    this.init();
  }
  
  init() {
    // Delegate click events for quick view buttons
    console.log('QuickView initialized')
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.quick-view-btn');

      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const productHandle = btn.dataset.productHandle;
        this.openQuickView(productHandle);
      }
    });
    
    // Close modal events
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.closeModal());
    }
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.closeModal());
    }
    
    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('active')) {
        this.closeModal();
      }
    });
    
    // Form submit
    if (this.form) {
      this.form.addEventListener('submit', (e) => this.handleAddToCart(e));
    }
  }
  
  async openQuickView(productHandle) {
    if (!productHandle) return;
    
    this.modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  
    const content = this.modal.querySelector('.qv-modal-content');
    if (content) content.scrollTop = 0;
  
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      
      if (!response.ok) {
        throw new Error('Product not found');
      }
      
      const product = await response.json();
      this.currentProduct = product;
      this.populateModal(product);
      
    } catch (error) {
      console.error('Error loading product:', error);
      alert('Sorry, there was an error loading this product. Please try again.');
      this.closeModal();
    }
  }
  
  populateModal(product) {
    // Title
    const titleEl = document.getElementById('qv-product-title');
    if (titleEl) titleEl.textContent = product.title;
    
    // Price
    this.updatePrice(product.price, product.compare_at_price);
    
    // Description
    const descEl = document.getElementById('qv-product-description');
    if (descEl) {
      // Create a temporary div to strip HTML if needed
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = product.description;
      descEl.textContent = tempDiv.textContent || tempDiv.innerText || '';
    }
    
    // Main image
    const mainImage = document.getElementById('qv-featured-image');
    if (mainImage && product.featured_image) {
      mainImage.src = product.featured_image;
      mainImage.alt = product.title;
    }
    
    // Thumbnails
    this.populateThumbnails(product.images || [product.featured_image]);
    
    // Variants
    this.populateVariants(product);
    
    // Full details link
    const detailsLink = document.getElementById('qv-view-full-details');
    if (detailsLink) {
      detailsLink.href = `/products/${product.handle}`;
    }
  }
  
  updatePrice(price, compareAtPrice) {
    const priceContainer = document.getElementById('qv-product-price');
    if (!priceContainer) return;
    
    const formattedPrice = this.formatMoney(price);
    let priceHTML = `<span class="price-item price-item--regular">${formattedPrice}</span>`;
    
    if (compareAtPrice && compareAtPrice > price) {
      const formattedComparePrice = this.formatMoney(compareAtPrice);
      priceHTML = `<s class="price-item price-item--regular">${formattedComparePrice}</s>` + priceHTML;
    }
    
    priceContainer.innerHTML = priceHTML;
  }
  
  formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return `RS.${dollars}`;
  }
  
  populateThumbnails(images) {
    const container = document.getElementById('qv-thumbnails');
    if (!container) return;
    
    container.innerHTML = '';
    
    if (!images || images.length <= 1) {
      container.style.display = 'none';
      return;
    }
    
    container.style.display = 'flex';
    
    images.forEach((imageSrc, index) => {
      const thumb = document.createElement('div');
      thumb.className = `qv-thumbnail ${index === 0 ? 'active' : ''}`;
      thumb.innerHTML = `<img src="${imageSrc}" alt="Product image ${index + 1}">`;
      
      thumb.addEventListener('click', () => {
        const mainImage = document.getElementById('qv-featured-image');
        if (mainImage) mainImage.src = imageSrc;
        
        container.querySelectorAll('.qv-thumbnail').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
      
      container.appendChild(thumb);
    });
  }
  
  populateVariants(product) {
    const container = document.getElementById('qv-variants-container');
    if (!container) return;
    
    container.innerHTML = '';
    
    // Single variant product
    if (product.variants.length === 1 && product.variants[0].title === 'Default Title') {
      container.innerHTML = `<input type="hidden" name="id" value="${product.variants[0].id}">`;
      this.updateAddToCartButton(product.variants[0]);
      return;
    }
    
    // Multi-variant product
    product.options.forEach((option, optionIndex) => {
      if (option.name === 'Title') return;
      
      const optionDiv = document.createElement('div');
      optionDiv.className = 'qv-variant-option';
      
      const label = document.createElement('label');
      label.textContent = option.name;
      label.htmlFor = `qv-option-${optionIndex}`;
      
      const select = document.createElement('select');
      select.name = `option${optionIndex + 1}`;
      select.id = `qv-option-${optionIndex}`;
      select.dataset.optionIndex = optionIndex;
      
      option.values.forEach(value => {
        const optionEl = document.createElement('option');
        optionEl.value = value;
        optionEl.textContent = value;
        select.appendChild(optionEl);
      });
      
      select.addEventListener('change', () => this.updateVariant(product));
      
      optionDiv.appendChild(label);
      optionDiv.appendChild(select);
      container.appendChild(optionDiv);
    });
    
    // Hidden variant ID field
    const variantInput = document.createElement('input');
    variantInput.type = 'hidden';
    variantInput.name = 'id';
    variantInput.id = 'qv-variant-id';
    container.appendChild(variantInput);
    
    // Set initial variant
    this.updateVariant(product);
  }
  
  updateVariant(product) {
    const selects = document.querySelectorAll('#qv-variants-container select');
    const selectedOptions = Array.from(selects).map(select => select.value);
    
    const variant = product.variants.find(v => {
      return selectedOptions.every((option, index) => v.options[index] === option);
    });
    
    if (variant) {
      const variantIdInput = document.getElementById('qv-variant-id');
      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }
      
      // Update price
      this.updatePrice(variant.price, variant.compare_at_price);
      
      // Update button
      this.updateAddToCartButton(variant);
      
      // Update image if variant has one
      if (variant.featured_image) {
        const mainImage = document.getElementById('qv-featured-image');
        if (mainImage) {
          mainImage.src = variant.featured_image.src;
        }
      }
    }
  }
  
  updateAddToCartButton(variant) {
    const btn = document.querySelector('.qv-add-to-cart-btn');
    const btnText = btn ? btn.querySelector('span') : null;
    
    if (!btn || !btnText) return;
    
    if (variant.available) {
      btn.disabled = false;
      btnText.textContent = 'Add to Cart';
    } else {
      btn.disabled = true;
      btnText.textContent = 'Sold Out';
    }
  }
  
  async handleAddToCart(e) {
    e.preventDefault();
    
    const formData = new FormData(this.form);
    const btn = document.querySelector('.qv-add-to-cart-btn');
    const btnText = btn ? btn.querySelector('span') : null;
    
    if (!btn || !btnText) return;
    
    const originalText = btnText.textContent;
    btnText.textContent = 'Adding...';
    btn.disabled = true;
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }
      
      const data = await response.json();
      
      // Success
      btnText.textContent = 'Added!';
      
      // Update cart if theme has cart functionality
      if (typeof window.theme !== 'undefined' && window.theme.cart) {
        window.theme.cart.getCart();
      }
      
      // Trigger custom event for other scripts
      document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
      
      // Close after delay
      setTimeout(() => {
        this.closeModal();
        btnText.textContent = originalText;
        btn.disabled = false;
      }, 1000);
      
    } catch (error) {
      console.error('Error adding to cart:', error);
      btnText.textContent = 'Error - Try Again';
      btn.disabled = false;
      
      setTimeout(() => {
        btnText.textContent = originalText;
      }, 2000);
    }
  }
  
  closeModal() {
    this.modal.classList.remove('active');
    document.body.style.overflow = '';
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new QuickView());
} else {
  new QuickView();
}